import script from "./GroupLeaderDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupLeaderDashboard.vue?vue&type=script&setup=true&lang=js"

import "./GroupLeaderDashboard.vue?vue&type=style&index=0&id=0caa151a&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0caa151a"]])

export default __exports__